// Shell contract: the top bar renders only feature-agnostic chrome — a back
// button and empty center/right slots. Feature-specific UI must be mounted
// by the feature's own components via TopBarSlot, so the shell never knows
// which features are enabled.

import {ActionIcon, Tooltip} from "@mantine/core";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import IconArrowLeft from "../../../assets/arrow-left.svg?react";
import {useTopBarSlots} from "../TopBarContext";
import {isDashboardPath} from "../../../paths";
import classes from "./TopBar.module.css";

export const TopBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const {setCenterEl, setRightEl} = useTopBarSlots();

    if (isDashboardPath(location.pathname)) {
        // DashboardLayout renders its own toggle inside the sticky top area.
        return null;
    }

    return (
        <div className={classes.topBar} data-icon-count={1}>
            <div className={classes.left}>
                <Tooltip label={t("common.goBack")}>
                    <ActionIcon
                        size="lg"
                        radius="xl"
                        variant="subtle"
                        color="gneis"
                        title={t("common.goBack")}
                        onClick={() => navigate("/")}
                        className={classes.iconButton}
                    >
                        <IconArrowLeft width={20} />
                    </ActionIcon>
                </Tooltip>
            </div>
            <div className={classes.constrainer}>
                <div ref={setCenterEl} className={classes.center} />
                <div ref={setRightEl} className={classes.right} />
            </div>
        </div>
    );
};
